import { useState } from "react";
import { faqs } from "../../../mocks/trendData";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-900">
              <i className="ri-question-answer-line" aria-hidden="true"></i> 常见问题
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              吃瓜前，先看看这些
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于更新节奏、内容质量与投稿方式，我们整理了大家最常问的几个问题。
              如果还有疑惑，欢迎通过页面下方的联系表单随时咨询。
            </p>
            <div className="mt-5 hidden items-center gap-3 rounded-xl border border-background-200 bg-background-50 p-4 lg:flex">
              <span className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-accent-100 text-xl text-accent-700">
                <i className="ri-customer-service-2-line" aria-hidden="true"></i>
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">编辑部在线答疑</p>
                <p className="text-xs text-foreground-500">工作日 10:00 - 18:00</p>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-3 lg:col-span-3">
            {faqs.map((f, idx) => {
              const open = openIdx === idx;
              return (
                <div
                  key={idx}
                  className={`overflow-hidden rounded-xl border bg-background-50 transition-colors ${
                    open ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? null : idx)}
                    className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                  >
                    <h3 className="text-sm font-semibold text-foreground-950 md:text-base">{f.q}</h3>
                    <span
                      className={`grid h-8 w-8 shrink-0 place-items-center rounded-full transition-colors ${
                        open ? "bg-primary-500 text-white" : "bg-background-100 text-foreground-600"
                      }`}
                    >
                      <i
                        className={`transition-transform ${open ? "ri-subtract-line" : "ri-add-line"}`}
                        aria-hidden="true"
                      ></i>
                    </span>
                  </button>
                  {open && (
                    <p className="px-4 pb-4 text-sm leading-relaxed text-foreground-600 md:px-5 md:text-base">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}